import { render, staticRenderFns } from "./CustomerProfitExtract.vue?vue&type=template&id=7a15e856&scoped=true&"
import script from "./CustomerProfitExtract.vue?vue&type=script&lang=js&"
export * from "./CustomerProfitExtract.vue?vue&type=script&lang=js&"
import style0 from "./CustomerProfitExtract.vue?vue&type=style&index=0&id=7a15e856&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a15e856",
  null
  
)

export default component.exports